import type { SizeType } from 'antd/lib/config-provider/SizeContext';

export const INSTALL_METER_DETAIL_FORM_LAYOUT_CONFIG = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 24 },
    lg: { span: 12 },
    xl: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 24 },
    lg: { span: 12 },
    xl: { span: 14 },
  },
  size: 'large' as SizeType,
};
